import { render, staticRenderFns } from "./item-divider.vue?vue&type=template&id=5f657924&scoped=true&"
import script from "./item-divider.vue?vue&type=script&lang=ts&"
export * from "./item-divider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f657924",
  null
  
)

export default component.exports